module.exports = __webpack_public_path__ + "media/customizations/pecansquarelife/logo-8e518afb8a2be8dd0fd32cae82fb97dc.png";